import React from 'react'
import List from '../crud/list'
import menuItems from './menuItems'
import { userEmailHydrator } from '../../fieldOptions/hydrators'

const columns = [
  { title: 'User', prop: 'user_id', references: 'admin/users', referenceProp: 'name' },
  { title: 'Institution', prop: 'institution_id', references: 'admin/institutions', referenceProp: 'name' },
  { title: 'Account Holder', prop: 'is_account_holder', format: 'bool' },
  { title: 'Primary Account', prop: 'is_primary_account_holder', format: 'bool' },
  { title: 'Created', prop: 'created_at', format: 'fromNow' },
  { title: 'Updated', prop: 'updated_at', format: 'fromNow' }
]

const filters = [
  { name: 'Filter by institution', prop: 'filters.institution_id', type: 'autocomplete', references: 'admin/institutions', referenceProp: 'name', enabled: true },
  { name: 'Filter by user', prop: 'filters.user_id', type: 'autocomplete', references: 'admin/users', dataHydrator: userEmailHydrator, referenceProp: 'fullname', displayProp: 'displayVal', enabled: true }
]

const defaults = {
  order: [{ column: 'created_at', direction: 'desc' }]
}

const InstitutionUsers = (props) => (
  <List
    title='Institution Users'
    apiPath='admin/institution_users'
    columns={columns}
    filters={filters}
    defaults={defaults}
    buildMenuItems={menuItems}
    locationPathname={props.location.pathname}
    locationSearch={props.location.search}
    withExport
  />
)

export default InstitutionUsers
